export default __webpack_public_path__ + "static/media/socialFacebook.549d471a.svg";